/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TutorialDto } from '../models/TutorialDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TutorialService {

    /**
     * @param version 
     * @returns TutorialDto OK
     * @throws ApiError
     */
    public static listTutorials(
version: string,
): CancelablePromise<Array<TutorialDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Tutorial',
            path: {
                'version': version,
            },
        });
    }

}
